import { Component } from 'react';

class CollapsibleComponent extends Component {
    render() {
        return this.props.children;
    }
}

export default CollapsibleComponent;